import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, vModelCheckbox as _vModelCheckbox, createSlots as _createSlots, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "p-5 d-flex flex-column text-center text-primary" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }),
  /*#__PURE__*/_createElementVNode("div", { class: "big-text mt-1" }, [
    /*#__PURE__*/_createElementVNode("b", null, "Save Payer In Progress...")
  ])
], -1 /* HOISTED */)
const _hoisted_2 = { class: "p-2 pb-0" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-12 col-md-4 offset-md-1" }
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "payer" }, [
  /*#__PURE__*/_createTextVNode(" Payer "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_7 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_8 = { class: "col-12 col-md-3" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "effective-date" }, [
  /*#__PURE__*/_createTextVNode(" Effective Date "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = { class: "input-group date datepickerInput" }
const _hoisted_12 = ["value"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_14 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_15 = { class: "col-12 col-md-3" }
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "payer-type" }, [
  /*#__PURE__*/_createTextVNode(" Payer Type "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_18 = ["disabled"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("option", { value: undefined }, "Select Payer Type", -1 /* HOISTED */)
const _hoisted_20 = ["value"]
const _hoisted_21 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_22 = {
  key: 0,
  class: "col-12 col-md-10 offset-md-1"
}
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", {
  class: "alert alert-warning mb-2",
  role: "alert"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-exclamation-triangle text-warning me-2" }),
  /*#__PURE__*/_createTextVNode(" This payer is not set up as a room and board payer. "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "/list/payer-edit/${selectedPayor.value}/billing-information",
    target: "_blank"
  }, "Click here"),
  /*#__PURE__*/_createTextVNode(" to update the payer’s setup to include room & board billing. ")
], -1 /* HOISTED */)
const _hoisted_24 = [
  _hoisted_23
]
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  key: 1,
  class: "row w-100"
}
const _hoisted_28 = {
  key: 2,
  class: "col-12 row form-group"
}
const _hoisted_29 = { class: "col-md-10 offset-md-1 px-0" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "comments" }, " Comments ", -1 /* HOISTED */)
const _hoisted_31 = { class: "col-md-10 offset-md-1 px-0" }
const _hoisted_32 = { class: "form-check custom-checkbox mt-2" }
const _hoisted_33 = ["id"]
const _hoisted_34 = ["for"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Benefits Verified", -1 /* HOISTED */)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_NonMedicarePayor = _resolveComponent("NonMedicarePayor")!
  const _component_MedicarePayor = _resolveComponent("MedicarePayor")!
  const _component_FormSection = _resolveComponent("FormSection")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    "application-id": _ctx.referral.application,
    showBackground: false,
    size: "0"
  }, _createSlots({ _: 2 /* DYNAMIC */ }, [
    (_ctx.isLoading)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _hoisted_1
          ])
        }
      : undefined,
    (!_ctx.isLoading)
      ? {
          name: "content",
          fn: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _createVNode(_component_TypeaheadInput, {
                      getData: _ctx.getPayors,
                      value: _ctx.initialValue,
                      onValueChanged: _ctx.selectedPayorChangedd,
                      "init-value": _ctx.selectedPayor,
                      placeholder: "Start Typing...",
                      debounce: 100,
                      disabled: !_ctx.isAddForm,
                      onBlurredInput: _ctx.v$.payer.agencyPayorName.$touch,
                      class: _normalizeClass(`${!_ctx.v$.payer.agencyPayorName.$error ? '' : 'field-invalid'}`)
                    }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "init-value", "disabled", "onBlurredInput", "class"]),
                    (_ctx.v$.payer.agencyPayorName.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_7, "Payer is required."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _createVNode(_component_DatePicker, { getDate: _ctx.changeEffectiveDate }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("input", {
                            type: "text",
                            name: "effective-date",
                            class: _normalizeClass(["form-control", `${!_ctx.v$.payer.effectiveDate.$error ? '' : 'field-invalid'}`]),
                            value: _ctx.formatDateInput(_ctx.payer.effectiveDate),
                            onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleDateChange && _ctx.handleDateChange(...args))),
                            placeholder: "MM/DD/YYYY",
                            autocomplete: "off",
                            onBlur: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.effectiveDate.$touch && _ctx.v$.payer.effectiveDate.$touch(...args)))
                          }, null, 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_12),
                          _hoisted_13,
                          (_ctx.v$.payer.effectiveDate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Effective Date is required."))
                            : _createCommentVNode("v-if", true)
                        ])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["getDate"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _hoisted_17,
                    _withDirectives(_createElementVNode("select", {
                      class: _normalizeClass(["form-select", `${!_ctx.v$.payer.type.$error ? '' : 'field-invalid'}`]),
                      name: "payer-type",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payer.type) = $event)),
                      onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.payerTypeUpdated())),
                      disabled: !_ctx.isAddForm,
                      onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.type.$touch && _ctx.v$.payer.type.$touch(...args)))
                    }, [
                      _hoisted_19,
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.payorTypeEnum), ([key, value]) => {
                        return (_openBlock(), _createElementBlock("option", {
                          value: value.value
                        }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_20))
                      }), 256 /* UNKEYED_FRAGMENT */))
                    ], 42 /* CLASS, PROPS, HYDRATE_EVENTS */, _hoisted_18), [
                      [_vModelSelect, _ctx.payer.type]
                    ]),
                    (_ctx.v$.payer.type.$error)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_21, "Type is required."))
                      : _createCommentVNode("v-if", true)
                  ])
                ]),
                (_ctx.showRoomAndBoardWarning && !_ctx.payer.isCharity)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_22, _hoisted_24))
                  : _createCommentVNode("v-if", true)
              ]),
              (_ctx.payer.agencyPayorId && !_ctx.payer.isCharity)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                    (!_ctx.payer.isMedicare)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                          _createVNode(_component_NonMedicarePayor, {
                            payer: _ctx.payer,
                            relationshipToInsuredEnum: _ctx.relationshipToInsuredEnum,
                            payerSequenceCodeEnum: _ctx.payerSequenceCodeEnum,
                            hasDeductibleMetChanged: _ctx.hasDeductibleMetChanged,
                            isApplicationPalliative: _ctx.isApplicationPalliative,
                            showSubscriberName: _ctx.showSubscriberName,
                            roomAndBoardTypeValue: _ctx.roomAndBoardTypeValue,
                            requireAuthorizationChanged: _ctx.requireAuthorizationChanged,
                            outOfPocketMaxMetChanged: _ctx.outOfPocketMaxMetChanged
                          }, null, 8 /* PROPS */, ["payer", "relationshipToInsuredEnum", "payerSequenceCodeEnum", "hasDeductibleMetChanged", "isApplicationPalliative", "showSubscriberName", "roomAndBoardTypeValue", "requireAuthorizationChanged", "outOfPocketMaxMetChanged"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.payer.isMedicare)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                          _createVNode(_component_MedicarePayor, {
                            payer: _ctx.payer,
                            isApplicationPalliative: _ctx.isApplicationPalliative,
                            requireAuthorizationChanged: _ctx.requireAuthorizationChanged,
                            outOfPocketMaxMetChanged: _ctx.outOfPocketMaxMetChanged,
                            getDate: _ctx.medicareDateChange
                          }, null, 8 /* PROPS */, ["payer", "isApplicationPalliative", "requireAuthorizationChanged", "outOfPocketMaxMetChanged", "getDate"])
                        ]))
                      : _createCommentVNode("v-if", true),
                    (_ctx.isApplicationPalliative)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _hoisted_30,
                            _withDirectives(_createElementVNode("textarea", {
                              class: "form-control",
                              id: "comments",
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payer.comments) = $event)),
                              rows: "4",
                              maxlength: "2000"
                            }, null, 512 /* NEED_PATCH */), [
                              [_vModelText, _ctx.payer.comments]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_31, [
                            _createElementVNode("div", _hoisted_32, [
                              _withDirectives(_createElementVNode("input", {
                                type: "checkbox",
                                id: `benefits-verified_${_ctx.payer.agencyId}`,
                                class: "form-check-input",
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payer.isBenefitVerified) = $event))
                              }, null, 8 /* PROPS */, _hoisted_33), [
                                [_vModelCheckbox, _ctx.payer.isBenefitVerified]
                              ]),
                              _createElementVNode("label", {
                                class: "form-check-label",
                                for: `benefits-verified_${_ctx.payer.agencyId}`
                              }, _hoisted_36, 8 /* PROPS */, _hoisted_34)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("v-if", true)
                  ]))
                : _createCommentVNode("v-if", true)
            ])
          ])
        }
      : undefined
  ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["application-id"]))
}